import React from 'react';
import { Alert, Button, Container } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';

const ImpersonationBanner: React.FC = () => {
  const { isImpersonating, impersonatedUser, stopImpersonation } = useAuth();

  if (!isImpersonating || !impersonatedUser) {
    return null;
  }

  const handleStopImpersonation = async () => {
    try {
      await stopImpersonation();
      window.location.reload();
    } catch (error) {
      console.error('Failed to stop impersonation:', error);
    }
  };

  return (
    <Alert variant="warning" className="mb-0 rounded-0 py-2">
      <Container className="d-flex justify-content-between align-items-center">
        <span>
          <strong>Admin Mode:</strong> You are viewing the app as{' '}
          <strong>{impersonatedUser.username}</strong> ({impersonatedUser.tier} tier)
        </span>
        <Button variant="dark" size="sm" onClick={handleStopImpersonation}>
          Return to Admin
        </Button>
      </Container>
    </Alert>
  );
};

export default ImpersonationBanner;
